import { ICustomFieldPermission } from '../common/model/customFieldPermission.model';

export const getCustomFieldPermissionByCode = (customFieldPermissions: ICustomFieldPermission[], code: string): ICustomFieldPermission => {
  return customFieldPermissions.find((p) => p.code === code) || null;
}
